import React from 'react'

import { withTranslate } from 'react-redux-multilingual'

import { CardActions, Grid } from '@material-ui/core'

import Button from '../../../../UI/Button/Button'

const empDetailFooter = ({
  empPositions,
  dropdownOptions,
  saveButtonClicked,
  cancelButtonClicked,
  formIsValid,
  validate,
  translate
}) => {
  return (
    <CardActions>
      <Grid container justify={'flex-end'} spacing={1}>
        <Grid item xs sm={3} md={2}>
          <Button color={'primary'} clicked={saveButtonClicked} disabled={!validate}>
            {translate('save')}
          </Button>
        </Grid>
        <Grid item xs sm={3} md={2}>
          <Button color={'default'} clicked={cancelButtonClicked}>
            {translate('cancel')}
          </Button>
        </Grid>
      </Grid>
    </CardActions>
  )
}

export default withTranslate(empDetailFooter)
